<template>
    <el-row :gutter="30"  class="mw-100 manage-testimonial" >
        
        <el-col :lg="24" :xs="24">
            
            <el-card>
                <el-form
                    class="text-center font-24" 
                    ref="addParentTestimonialRef"
                    :model="currentTestimonialData"
                    :rules="currentTestimonialDataRules"
                    label-position="top"
                >
                    <el-row :gutter="30">
                        <el-col :lg="24" :xs="24">
                            <el-form-item>
                                <el-button type="primary" @click="manageTestimonial('addTestimonialRef')" class="text-cap">
                                    <font-awesome-icon :icon="['fas', 'floppy-disk']" style="width:20px" class="mr-10" />
                                    save
                                </el-button>
                            </el-form-item>
                        </el-col>
                        
                        <el-col :lg="12" :xs="24">
                            <el-form-item  label="testimonial image" prop="imageBase64">
                                <el-image 
                                    style="width: 250px; height: 250px;margin-right:20px" 
                                    :src="isAddTestimonial ? currentTestimonialData.imageURL :  $getImage(currentTestimonialData.imageURL) || ''" 
                                    fit="cover"
                                    :zoom-rate="1.2"
                                    :preview-src-list="[isAddTestimonial ? currentTestimonialData.imageURL : $getImage(currentTestimonialData.imageURL)]"
                                    :preview-teleported="true"
                                >
                                    <template #error>
                                        <div class="image-slot">
                                            <font-awesome-icon :icon="['fas', 'image']" />
                                        </div>
                                    </template>
                                </el-image>
                                <el-upload
                                    ref="imageBase64"
                                    action="#"
                                    :auto-upload="false"
                                    :on-change="onUploadImage"
                                    
                                    :on-remove="handleRemoveImage"
                                    accept="image/png, image/jpeg,image/gif"
                                    class="font-24 d-flex align-center flex-1"
                                >
                                    <font-awesome-icon :icon="['fas', 'upload']" style="width:20px" class="mr-10" />
                                </el-upload>
                            </el-form-item>
                            
                        </el-col>
                        <el-col :lg="12" :xs="24">
                            
                            <el-form-item  label="testimonial Logo" prop="image2Base64">
                                <el-image 
                                    style="width: 250px; height: 250px;margin-right:20px" 
                                    :src="isAddTestimonial ? currentTestimonialData.image2URL :  $getImage(currentTestimonialData.image2URL) || ''" 
                                    fit="cover"
                                    :zoom-rate="1.2"
                                    :preview-src-list="[isAddTestimonial ? currentTestimonialData.image2URL : $getImage(currentTestimonialData.image2URL)]"
                                    :preview-teleported="true"
                                >
                                    <template #error>
                                        <div class="image-slot">
                                            <font-awesome-icon :icon="['fas', 'image']" />
                                        </div>
                                    </template>
                                </el-image>
                                <el-upload
                                    ref="image2Base64"
                                    action="#"
                                    :auto-upload="false"
                                    :on-change="onUploadImage2"
                                    
                                    :on-remove="handleRemoveImage2"
                                    accept="image/png, image/jpeg,image/gif"
                                    class="font-24 d-flex align-center flex-1"
                                >
                                    <font-awesome-icon :icon="['fas', 'upload']" style="width:20px" class="mr-10" />
                                </el-upload>
                            </el-form-item>
                        </el-col>
                        
                        
                    </el-row>
                </el-form>
                <el-tabs  tab-position="left">
                    <el-tab-pane  v-for="(item, index) in currentTestimonialData.translates" :key="index" >
                        <template #label>
                            <span class="custom-tabs-label">
                                <span>
                                    {{$getLanguageName(item.languageID)}}
                                </span>
                            </span>
                        </template>
                        <el-form 
                            class="text-center font-24" 
                            ref="addTestimonialRef"
                            :model="currentTestimonialData"
                            :rules="currentTestimonialDataRules"
                            label-position="top"
                        >
                            <el-row :gutter="30">
                               
                                <el-col :lg="24" :xs="24">
                                    <el-form-item  label="title" :prop="`translates[${index}].title`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                        <el-input type="text" v-model="currentTestimonialData.translates[index].title"></el-input>    
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :xs="24">
                                    <el-form-item  label="description" :prop="`translates[${index}].description`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                        <el-input type="text" v-model="currentTestimonialData.translates[index].description"></el-input>    
                                    </el-form-item>
                                </el-col>
                               
                                
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
            </el-card>
        </el-col>
    </el-row>
    
</template>

<script>
export default {
    data(){
        return {
            isAddTestimonial:true,
            currentTestimonial:[],
            fileList:[],
            dialogVisible:false,
            dialogImageUrl:'',
            fileUploaded:false,

            currentTestimonialData:{},
            currentTestimonialDataRules:{
                value:{
                    required:true,
                    message:'required field',
                    trigger:'blur',
                },
                translates:this.$setTranslateRules(['title','description']),
            }
        };
    },
    computed:{
        cachedTestimonial(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.home?.testimonials.currentTestimonial || {}
        }
    },
    mounted(){
        if (this.$route.params.id && this.$route.params.id == this.cachedTestimonial.id) {
            this.isAddTestimonial = false;
            this.currentTestimonialData = JSON.parse(JSON.stringify(this.cachedTestimonial))
            this.currentTestimonialData.translates = this.$filterPublishedTranslates(this.currentTestimonialData.translates)
        }else{
            this.$router.push({
                name:'manage-testimonial',
            })
            this.currentTestimonialDataRules.imageBase64 = [
                {
                    required:true,
                    trigger:'blur',
                    message:'required field'

                }
            ]
            this.currentTestimonialDataRules.image2Base64 = [
                {
                    required:true,
                    trigger:'blur',
                    message:'required field'

                }
            ]
            this.isAddTestimonial = true;
            this.currentTestimonialData = this.initState()
        }
    },
    
    methods:{
        initState(){
            return {
                imageBase64:'',
                image2Base64:'',
                translates:this.$setTranslateKeys({
                    'title':'',
                    'description':'',
                })
            }
        },
       
        async manageTestimonial(formName){
            let successForm = [];
            this.$refs['addParentTestimonialRef'].validate(async (parentValid) => {
                if (parentValid) {
                    for (let index = 0; index < this.$refs[formName].length; index++) {
                        const element = this.$refs[formName][index];
                        element.validate(async (valid) => {
                            if (!valid) {
                                this.$message({
                                    message:`please fill the data in the ${this.$getOrderName(index + 1)} tab `,
                                    type:'info',
                                    duration:5000,
                                    showClose: true,
                                });
                            }
                        }).then(data =>{
                            let indexOfIndex = successForm.indexOf(index);
                            if (data){
                                successForm.push(index);
                                if (successForm.length == this.$refs['addTestimonialRef'].length){
                                    this.manageTestimonialAfterValidate()
                                }
                            }else{
                                if(indexOfIndex != -1) {
                                    successForm.splice(indexOfIndex,1);
                                }
                            }
                        })  
                    }
                }else{
                    return false
                }
            })
            
           
            
            
            
            
            
        },
        async manageTestimonialAfterValidate(){
            
            const response = await this.$store.dispatch(this.isAddTestimonial ? 'addTestimonial':'updateTestimonial',this.currentTestimonialData);
            if (response.data.status == 1) {
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
                await this.$store.dispatch('getAllTestimonials');
                this.$router.push({
                    name:'testimonials-list'
                })
            }
        },
        onUploadImage(file){
            if((file.size / Math.pow(1024, 2)).toFixed(2) * 1 > 5){
                this.$notify({
                    title:'File Size Exceded',
                    message:'the file uplaoded should be less than 5 MB',
                    type:'warning',
                });
                this.$refs['imageBase64'][0].clearFiles()
            }else{  
                const FR = new FileReader();
                let module = this;
                FR.addEventListener("load", function(evt) {
                    module.currentTestimonialData.imageBase64 = evt.target.result;
                }); 
                this.currentTestimonialData.imageURL =  URL.createObjectURL(file.raw);

                FR.readAsDataURL(file.raw);
            }
        },    
        handleRemoveImage(){
            this.currentTestimonialData.imageURL = this.isAddTestimonial ? '' : this.cachedTestimonial.imageURL
        }, 
        onUploadImage2(file){
            if((file.size / Math.pow(1024, 2)).toFixed(2) * 1 > 5){
                this.$notify({
                    title:'File Size Exceded',
                    message:'the file uplaoded should be less than 5 MB',
                    type:'warning',
                });
                this.$refs['image2Base64'][0].clearFiles()
            }else{  
                const FR = new FileReader();
                let module = this;
                FR.addEventListener("load", function(evt) {
                    module.currentTestimonialData.image2Base64 = evt.target.result;
                }); 
                this.currentTestimonialData.image2URL =  URL.createObjectURL(file.raw);

                FR.readAsDataURL(file.raw);
            }
        },    
        handleRemoveImage2(){
            this.currentTestimonialData.image2URL = this.isAddTestimonial ? '' : this.cachedTestimonial.image2URL
        }, 
    }
}
</script>
<style lang="scss">
    .manage-testimonial {
        .ck-editor {
            width:100%;
        }
    }
</style>